import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PorIcon, PorIconModule } from '@por/shared/ui/icon-lib';
import { ApxTabDirective } from '../directives/tab.directive';

let tabCount = 1;
@Component({
    selector: 'apx-tab',
    standalone: true,
    imports: [CommonModule, PorIconModule],
    templateUrl: './tab.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApxTabComponent implements OnInit {
    cdr = inject(ChangeDetectorRef);

    /*
     *  Code below set and used in the tab-group component
     */
    @Output() readonly clicked = new EventEmitter<string>();
    @ViewChild('projectedContent') projectedContent!: TemplateRef<void>;
    @ViewChild('tabElement') tabElement!: ElementRef;
    @ContentChild(ApxTabDirective, { static: false, read: TemplateRef<void> })
    templateContent: TemplateRef<void> | null = null;

    /*
     *  Code below set by developer
     */
    @Input() title!: string;
    /*
     *  Should be unique for each tab in a tab group. Set to title if not provided.
     *  This will work if there is no title or value. However, the user will not be able to select the tab programatically if they do so.
     */
    @Input() value!: string;

    /**
     * Configure the position of the icon with respect to the projected content
     */
    @Input() iconPos: 'before' | 'after' | 'noTitle' = 'before';

    /**
     * Apex name of the icon.
     * Available icons are contained within the enum.
     */
    @Input() icon!: PorIcon;

    get content(): TemplateRef<void> {
        return this.templateContent || this.projectedContent;
    }

    get isFocusedOn() {
        return this.tabElement.nativeElement === document.activeElement;
    }

    get selected() {
        return this._selected;
    }

    set selected(isSelected) {
        this._selected = isSelected;
        this.cdr.markForCheck();
    }

    private _selected = false;

    ngOnInit() {
        if (!this.value) {
            this.value = this.title || `untitledTab${tabCount++}`;
        }
    }

    focusOnTab() {
        this.tabElement.nativeElement.focus();
    }
}
